import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCities } from '@/api/queries/reference';
import { Input } from '@/components/ui/Input';
import { Spinner } from '@/components/ui/Spinner';
import styles from './CountryPicker.module.css';

interface CitiesPickerProps {
  countryCode: string;
  value?: string | null;
  onPick: (cityId: string, cityName: string) => void;
}

export function CitiesPicker({ countryCode, value, onPick }: CitiesPickerProps): JSX.Element {
  const { t } = useTranslation();
  const [q, setQ] = useState('');
  const { data, isLoading } = useCities(countryCode, q);

  return (
    <div className={styles.wrap}>
      <Input
        autoFocus
        placeholder={t('common.search_placeholder')}
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      <div className={styles.scroll}>
        {isLoading && <Spinner />}
        {(data ?? []).map((c) => (
          <button
            key={c.id}
            type="button"
            className={`${styles.row} ${value === c.id ? styles.active : ''}`}
            onClick={() => onPick(c.id, c.name)}
          >
            <span className={styles.flag}>📍</span>
            <span className={styles.name}>{c.name}</span>
            {c.region_name && <span className={styles.code}>{c.region_name}</span>}
          </button>
        ))}
        {!isLoading && (data ?? []).length === 0 && <div className={styles.empty}>—</div>}
      </div>
    </div>
  );
}
